import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'ApplyRecord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'ApplyRecord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'ApplyRecord',
    column_type: 'datetime',
  },
  target_type: {
    model_name: 'ApplyRecord',
    column_type: 'string',
  },
  target: {
    model_name: 'ApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: true,
      association_name: 'target',
      model_name: '',
      foreign_key: 'target_id',
    },
  },
  target_id: {
    model_name: 'ApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: true,
      association_name: 'target',
      model_name: '',
      foreign_key: 'target_id',
    },
  },
  user: {
    model_name: 'ApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  user_id: {
    model_name: 'ApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  state: {
    model_name: 'ApplyRecord',
    column_type: 'enum',
  },
  refund_reason: {
    model_name: 'ApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'refund_reason',
      model_name: 'Reason',
      foreign_key: 'refund_reason_id',
    },
  },
  refund_reason_id: {
    model_name: 'ApplyRecord',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'refund_reason',
      model_name: 'Reason',
      foreign_key: 'refund_reason_id',
    },
  },
  refund_reason_detail: {
    model_name: 'ApplyRecord',
    column_type: 'string',
  },
  price_type_name: {
    model_name: 'ApplyRecord',
    column_type: 'string',
  },
  price_type_amount: {
    model_name: 'ApplyRecord',
    column_type: 'decimal',
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
